import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SetToTop = () => {
  const { pathname } = useLocation();

  // Scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

export default SetToTop;